import { getCookie, setCookie } from './cookies';
import { fireHeapCustomerLogoutEvent } from './heap-events';

export const detectAndReportEarlyLogout = () => {
  try {
    const currentCustomer = window?.getCustomerInfo?.();
    const isCurrentlySignedIn = !!currentCustomer?.customerId;
    const lastAuthState = getCookie('alo-auth-tracking-lastAuthState');
    const lastCustomerId = getCookie('alo-auth-tracking-lastCustomerId');
    const authTimestamp = getCookie('alo-auth-tracking-authTimestamp');

    if (lastAuthState === 'signed_in' && !isCurrentlySignedIn && !getCookie('alo-auth-tracking-manualLogout')) {
      const sessionDuration = authTimestamp ? Date.now() - parseInt(authTimestamp) : undefined;

      import('./heap-events')
        .then(({ fireHeapEarlyLogoutEvent }) => {
          fireHeapEarlyLogoutEvent({
            lastKnownCustomerId: lastCustomerId || undefined,
            sessionDuration,
            pageUrl: window.location.href,
          });
        })
        .catch((err) => {
          console.error('Failed to load heap events for early logout detection:', err);
        });
    }

    // Update current auth state
    if (isCurrentlySignedIn) {
      setCookie('alo-auth-tracking-lastAuthState', 'signed_in', 30);
      setCookie('alo-auth-tracking-lastCustomerId', currentCustomer.customerId.toString(), 30);
      if (!authTimestamp) {
        setCookie('alo-auth-tracking-authTimestamp', Date.now().toString(), 30);
      }
    } else {
      setCookie('alo-auth-tracking-lastAuthState', 'signed_out', 30);
      setCookie('alo-auth-tracking-authTimestamp', '', -1);
    }

    setCookie('alo-auth-tracking-manualLogout', '', -1);
  } catch (err) {
    console.error('Error in early logout detection:', err);
  }
};

export const manualLogoutTracking = () => {
  setCookie('alo-auth-tracking-manualLogout', 'true', 1);
  fireHeapCustomerLogoutEvent();
};
